import {defineApiSlice} from '../../../core/createApi';
import {jsonRpcTransport} from '../../../core/transports/jsonRpcTransport';
import {getDomain} from '../../../utils/getDomain';
import type {MethodShape} from '../../../core/types';
import type {
  AssignPromoCodePrizeParams,
  AssignPromoCodePrizeResult,
  GetActiveLandingPrizeParams,
  GetActiveLandingPrizeResult,
} from './types';
import {isPlainObject} from '../../../../../utils/isPlainObject';

interface Methods extends Record<string, MethodShape> {
  assignLandingDeliveryPromoCodePrize: {params: AssignPromoCodePrizeParams; result: AssignPromoCodePrizeResult};
  getActiveLandingPrize: {params: GetActiveLandingPrizeParams; result: GetActiveLandingPrizeResult};
}

const mapAssignResponse = (raw: unknown): AssignPromoCodePrizeResult => {
  if (isPlainObject(raw) && 'success' in raw) {
    return {success: raw.success === 'true' || raw.success === true};
  }
  return {success: false};
};

const mapActivePrizeResponse = (raw: unknown): GetActiveLandingPrizeResult => {
  if (isPlainObject(raw) && typeof raw.prizeId === 'string') {
    return {prizeId: raw.prizeId};
  }
  throw new Error('getActiveLandingPrize: prizeId is missing in response');
};

export const prizeManagementV1 = defineApiSlice<Methods>({
  path: 'prize-management-landing/api/v1',
  domain: getDomain(),
  defaultTransport: jsonRpcTransport(),
  methods: {
    assignLandingDeliveryPromoCodePrize: {mapResponse: mapAssignResponse},
    getActiveLandingPrize: {mapResponse: mapActivePrizeResponse},
  },
});
